import { render, staticRenderFns } from "./CustomFormTable.vue?vue&type=template&id=dd8fd7e6&scoped=true"
import script from "./CustomFormTable.vue?vue&type=script&lang=ts"
export * from "./CustomFormTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomFormTable.vue?vue&type=style&index=0&id=dd8fd7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8fd7e6",
  null
  
)

export default component.exports